<template>
  <div class="charts" id="map">

  </div>

</template>
<script>
  import echarts from 'echarts'
  import 'echarts/map/js/china'
  import { queryAreaOrderNumTotal } from  "@/api/order/orderinfo"
  export default {
    name: "map",
    props: {
      title: {
        type: String,
        default: () => (
          ''
        )
      },
    },
    data() {
      return {
      }
    },
    created() {
      queryAreaOrderNumTotal().then(res =>{
        if(res.data.code==0){
          this.$nextTick(() => {
            this.drawBar(res.data.data);
          })
        }
      })

    },
    methods: {
      drawBar(data) {
        let myChart = echarts.init(document.getElementById('map'));
        let option = {
          title:{
            text:'',
            x:'center'
          },
          tooltip:{//提示框组件
            show:true,
            trigger:'item',
            formatter: '{b}<br/>订单：{c}'// {a}（系列名称），{b}（区域名称），{c}（合并数值）, {d}（无）
          },
          visualMap:{//视觉映射组件
            type:'piecewise',//映射组件类型(1、piecewise--分段型;2、continuous--连续型)
            inRange:{
              color: ['#CCC', '#F2B252', '#D1241A']//数据段范围颜色
            },
            pieces: [//地图左下角显示可视化
              {min: 9999,color:'#D1241A'}, // 不指定 max，表示 max 为无限大（Infinity）。
              {min: 1000, max: 9999,color:'#F27152'},
              {min: 100, max: 999,color:'#F28E52'},
              {min: 10, max: 99,color:'#F2B252'},
              {min: 1, max: 9,color:'#A5A5A5'},
              {value: 0,color:'#F5F5F5'}, // 表示 value 等于 0 的情况。
            ]
          },
          series: [{
            name: '订单',
            type: 'map',
            map:'china',
            zoom:1.2,//地图显示大小调整(默认为1)
            data: data,
            label:{//区域名称显示
              //show:true
            },
            itemStyle:{//区域间样式调节
              borderColor:'lightblue'
            },
            emphasis:{//区域高亮显示时状态
              label:{//高亮时字体样式
                color: '#FFF',
              },
              itemStyle:{//高亮是区域样式
                areaColor:'#4EC8FF',
                borderColor:'#ccc'
              }
            }
          }]
        };
        myChart.setOption(option);
      }
    }
  };
</script>

<style scoped>
  .charts {
    background: #fff;
    width: 100%;
    height: 250px;
    box-shadow: 0px 2px 4px 0px rgba(187, 187, 187, 0.25);
    border-radius: 4px;
  }
</style>
